// @owners { team: patients }
import { SPACING } from '@alto/design-library-tokens';
import { Body, Card, Column, ExternalLink, Icon, MdPadding, Row, XsSpacing } from '@alto/design-system';
import React from 'react';
import { getCompanyPhone } from '~shared/config/getCompanyPhone';

export const BusinessHours = () => {
  const phoneNumber = getCompanyPhone();
  return (
    <Card
      title="Business Hours"
      flexGrow={1}
    >
      <MdPadding topPadding={SPACING.STATIC.NONE}>
        <Row wrap={false}>
          <>
            <Icon
              name="phone"
              type="disabled"
            />
            <XsSpacing />
          </>
          <Column flexGrow={1}>
            <Body fontFamily="semibold">Call</Body>
            <ExternalLink href={`tel:${phoneNumber}`}>{phoneNumber}</ExternalLink>
            <XsSpacing />
            <Column>
              <Body>Monday - Friday</Body>
              <Body>6 am - 9 pm PT</Body>
              <XsSpacing />
            </Column>
            <Body>Saturday & Sunday</Body>
            <Body>7 am - 6 pm PT</Body>
          </Column>
        </Row>
      </MdPadding>
    </Card>
  );
};
